import { AType, summon } from "@silversea-ssc/functional-support"
import * as O from "fp-ts/Option"
import { RpcRequest } from "../rpc-request"
import { Option } from "fp-ts/Option"

export const BadRequestCode = summon((F) =>
    F.keysOf({
        unknownAction: null,
        unknownCountry: null,
        infrastructure: null,
        invalidRequest: null,
    }),
)
export type BadRequestCode = AType<typeof BadRequestCode>

export const BadRequestResponseData = summon((F) =>
    F.interface(
        {
            errorCode: BadRequestCode(F),
            message: F.string(),
        },
        "BadRequestResponseData",
    ),
)
export type BadRequestResponseData = AType<typeof BadRequestResponseData>

export const BadRequestResponse = summon((F) =>
    F.interface(
        {
            action: F.string(),
            type: F.stringLiteral("BadRequestResponse"),
            requestId: F.nullable(F.string()),
            data: BadRequestResponseData(F),
        },
        "BadRequestResponse",
    ),
)
export type BadRequestResponse = AType<typeof BadRequestResponse>

export const fromRequest = (
    request: Pick<RpcRequest, "requestId" | "action">,
    errorCode: BadRequestCode,
    message: string,
): BadRequestResponse => ({
    action: request.action,
    type: "BadRequestResponse",
    requestId: O.some(request.requestId),
    data: {
        errorCode,
        message,
    },
})
export const fromAction = (
    action: string,
    requestId: Option<string>,
    errorCode: BadRequestCode,
    message: string,
): BadRequestResponse => ({
    action,
    type: "BadRequestResponse",
    requestId,
    data: {
        errorCode,
        message,
    },
})
export const unknownAction = (requestId: Option<string>, action: string): BadRequestResponse => ({
    action,
    type: "BadRequestResponse",
    requestId,
    data: {
        errorCode: "unknownAction",
        message: `Unknown action: ${action}`,
    },
})

export const strictType = BadRequestResponse.strictType
